import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { getCurrentUserRole } from 'modules/utilities/utility';
import { useApprovalsPageState } from 'modules/attendence_leave_tracker/store';
import { useToast } from "modules/navbar/top/store/toasterStore";
import { LEAVESTATUS, LEAVE_STATUS, userHouseConfig } from 'config';
import { LOCAL_STORAGE_CONFIG } from "config";
import moment from 'moment';
const { HOUSE, MODALSHOWN } = LOCAL_STORAGE_CONFIG;

const ApprovalPopUpForManager = () => {
  const navigate = useNavigate();
  const { setToaster } = useToast();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const { fetchApprovalFunc, approvalsData } = useApprovalsPageState();
  const currentHour = moment().hour();

  useEffect(() => {
    if (currentHour >= 17 && currentHour < 19) {
      fetchApprovalFunc(setToaster, { leaveStatus: LEAVESTATUS.PENDING });
    }
  }, []);

  useEffect(()=>{
    if (currentHour === 18) {
      showModal(approvalsData?.totalCount);
    }
  },[approvalsData])

  const showModal = (count) => {
    if (MODALSHOWN !== 'true' && getCurrentUserRole() === 'admin' && count !== 0  && userHouseConfig.includes(HOUSE)) {
      setTotalCount(count);
      setIsModalVisible(true);
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    secureLocalStorage.setItem('modalShown', 'true');
    navigate('/approvals-tracker');
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    secureLocalStorage.setItem('modalShown', 'true');
  };

  return (
    <Modal title="Pending Approvals" open={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
      <p>You have {totalCount} approvals pending in the approval tracker. Please approve them.</p>
    </Modal>
  );
};

export default ApprovalPopUpForManager;
